import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {faqData.title}
          </h2>
          <p className="text-sm text-foreground-600">关于51黑料网分区导航的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 font-heading">
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}